import { render, staticRenderFns } from "./TotalPoy.vue?vue&type=template&id=a20d9a2e&"
import script from "./TotalPoy.vue?vue&type=script&lang=js&"
export * from "./TotalPoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports